import React from 'react';
import { Button } from '@material-ui/core';
import { authenticatingUser } from 'redux/actions/auth';
import { loginUserWithRedirect } from 'auth/authUtils';
import { useDispatch, useSelector } from 'react-redux';

const LoginCard = (props) => {
    const { internalLinkCount } = props;
    const dispatch = useDispatch();
    const userAuthenticating = useSelector((state) => state.user.authenticatingUser);
    const authenticated = useSelector((state) => state.user.authenticated);

    const login = () => {
        dispatch(authenticatingUser());
        loginUserWithRedirect();
    };

    const getText = () => {
        let num = internalLinkCount;
        if (num < 1) return '';

        let are = 'are';
        let s = 's';
        let arent = "aren't";

        if (num < 2) {
            are = 'is';
            s = '';
            arent = "isn't";
        }

        let text = `There ${are} ${num} more link${s} that ${arent} being displayed.`;
        return text;
    };

    return (
        <div style={styles.card}>
            <p>{getText()}</p>
            {userAuthenticating && <div>Logging in...</div>}
            {!userAuthenticating && !authenticated && <Button variant='contained' color='primary' onClick={login}>Login</Button>}
        </div>
    );
};

export default LoginCard;

const styles = {
    card: {
        textAlign: 'center',
        margin: '25px 0',
    },
};
